import React from 'react';
import ChatbotAcoustique from './ChatbotAcoustique';
import { Button } from './ui/button';
import { ArrowLeft } from 'lucide-react';

const ChatbotPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center space-x-4 mb-6">
          <Button onClick={() => window.location.href = '/dashboard'} variant="ghost">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Retour au Dashboard
          </Button>
          <h1 className="text-3xl font-bold">Assistant Acoustique</h1>
        </div>
        
        <div className="flex justify-center">
          <ChatbotAcoustique isOpen={true} onClose={() => window.location.href = '/dashboard'} />
        </div>
      </div>
    </div>
  );
};

export default ChatbotPage;
